module.exports = __webpack_public_path__ + "img/myInitialEle.6e3d776f.svg";